export default __webpack_public_path__ + "static/media/loss-analysis-step-9.6773b2d7.gif";